/* eslint-disable no-nested-ternary */
import { XIcon } from '@phosphor-icons/react';
import React, { useContext } from 'react';
import { Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';
import { ContextChatbot } from 'components/templates/MainlayoutChatbot';
import mapModifiers from 'utils/functions';

interface ChatbotProps {
  openStatus: string;
  openBubbleMsgStatus: string;
  detectOpenStatus: () => void;
  detectCloseBubbleMsgStatus: () => void;
}

const ChatbotIcon: React.FC<ChatbotProps> = ({
  openStatus,
  detectOpenStatus,
  detectCloseBubbleMsgStatus,
  openBubbleMsgStatus
}) => {
  const infoChatbot = useContext(ContextChatbot);

  const handleOpen = () => {
    detectOpenStatus();
  };

  return (
    <div
      className="p-chatbotWidget_icon"
      style={{ '--avatar-size': `${infoChatbot.bubbleSize || 50}px` } as React.CSSProperties}
    >
      <div className="p-chatbotWidget_icon_avatarWrap">
        {infoChatbot.teaserMsg && (
          <div className={`p-chatbotWidget_icon_bubbleWrap ${mapModifiers('p-chatbotWidget_teaserMessage', openStatus !== 'open' && openBubbleMsgStatus !== 'close' && 'show')}`}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                detectCloseBubbleMsgStatus();
              }}
              className="p-chatbotWidget_icon_close"
            >
              <XIcon size={16} />
            </div>

            <div className="p-chatbotWidget_icon_bubble">
              <Typography.Text extendClasses="p-chatbotWidget_icon_bubbleText">
                {infoChatbot.teaserMsg}
              </Typography.Text>
            </div>
          </div>
        )}
        <div
          onClick={handleOpen}
          className="p-chatbotWidget_icon_avatar"
        >
          {openStatus === 'open' ? (
            <Icon iconName="evolCloseWidget" size="40" />
          )
            : infoChatbot.isLoadingChatBot ? null : (
              <img
                src={infoChatbot.bubbleAvatar || '/chatbotVideo.gif'}
                className="p-chatbotWidget_icon_video"
                alt={infoChatbot.name || 'Chatbot'}
              />
            )}
        </div>
      </div>
    </div>
  );
};

export default ChatbotIcon;
